class ExternalPropsParser {
    // eslint-disable-next-line class-methods-use-this
    isString(val) {
        return typeof val === 'string';
    }

    // eslint-disable-next-line class-methods-use-this
    isBinding(val) {
        return val.indexOf('{{') === 0;
    }

    parse(val, defaultValue) {
        if (this.isString(val)) {
            if (!this.isBinding(val)) {
                try {
                    return JSON.parse(val);
                } catch (e) {
                    return defaultValue;
                }
            } else {
                return defaultValue;
            }
        }
        return val;
    }

    parseString(value, defaultValue = '') {
        if (this.isBinding(value)) {
            return defaultValue;
        }
        return value;
    }

    parseObject(value, defaultValue = {}) {
        return this.parse(value, defaultValue);
    }

    parseBoolean(value, defaultValue = false) {
        return this.parse(value, defaultValue);
    }

    parseNumber(value, defaultValue = NaN) {
        return this.parse(value, defaultValue);
    }

    parseArray(value, defaultValue = []) {
        return this.parse(value, defaultValue);
    }

    setExternalProps(props, propsToParse) {
        const externalProps = { ...props };
        for (let i = 0; i < propsToParse.length; i++) {
            externalProps[propsToParse[i]] = {
                type: String
            };
        }
        return externalProps;
    }
}

export default new ExternalPropsParser();
